import { SuggestedAction } from '@common/interfaces/legalDocument'
import Base from './base'

export default class LegalApi extends Base {
  listDocuments(id: string) {
    return this.apiClient.get(`/client/${id}/legal/documents`)
  }
  parseLegalDocument(id: string, formData: FormData) {
    return this.apiClient.post(`/client/${id}/legal/document/parse`, formData)
  }

  getRedlines(
    id: string,
    fileId: string,
    params?: {
      page?: number
      perPage?: number
      // Explicit offset; the server prefers it over page * perPage because a page can
      // come back longer than perPage when a concept group runs past the boundary.
      skip?: number
      section?: string
      loadMore?: boolean
      resolutionFilter?: 'resolved' | 'unresolved'
      skipLoader?: boolean
    },
  ) {
    return this.apiClient.get(`/client/${id}/legal/document/${fileId}/redlines`, params)
  }

  getDocumentBuffer(id: string, fileId: string) {
    return this.apiClient.get(`/client/${id}/legal/document/${fileId}/buffer`)
  }

  deleteDocument(id: string, fileId: string) {
    return this.apiClient.delete(`/client/${id}/legal/document/${fileId}`)
  }

  updateRedline(
    id: string,
    fileId: string,
    redlineId: string,
    action: SuggestedAction | null,
    modifiedText?: string,
  ) {
    return this.apiClient.put(`/client/${id}/legal/document/${fileId}/redlines/${redlineId}`, {
      action,
      modifiedText,
    })
  }

  updateRedlinesBulk(
    id: string,
    fileId: string,
    redlineIds: string[],
    action: SuggestedAction | null,
  ) {
    return this.apiClient.put(`/client/${id}/legal/document/${fileId}/redlines-bulk`, {
      redlineIds,
      action,
    })
  }

  addRedlineComment(id: string, fileId: string, redlineId: string, comment: string | null) {
    return this.apiClient.post(
      `/client/${id}/legal/document/${fileId}/redlines/${redlineId}/comment`,
      {
        comment,
      },
    )
  }

  applyChanges(id: string, fileId: string) {
    return this.apiClient.post(`/client/${id}/legal/document/${fileId}/apply-changes`)
  }
}
